import { InjectionToken } from '@angular/core';
import { ClientAppId } from '../commons';
export const CLIENT_APP_ID = new InjectionToken<ClientAppId>('client-app-id');
